import React, { useState, useContext, useEffect } from 'react';
import RegisterInterestForm from './RegisterInterestForm';
import AddressContext from '../context/AddressContext';
import { graphql, useStaticQuery } from 'gatsby';
import PostcodeSearch from './PostcodeSearch';
import LitStructuredText from './generic/LitStructuredText';
import { useLocation } from '@gatsbyjs/reach-router';
import { Cookies } from 'react-cookie-consent';
import { RegionalPromoCookie, InterestCookie } from '../data/Cookies';
import LitImage from './images/LitImage';
import PostcodeRegisterInterestSwitch from './PostcodeRegisterInterestSwitch';
const ModularRegisterInterestForm = ({ data }) => {
  const { currentAddress, setCurrentAddress } = useContext(AddressContext);

  const {
    backgroundColor,
    noBottomPadding,
    noTopPadding,
    orderableText,
    unorderableText,
    postcodeNotSearchedText,
    smallText,
    arrowsLeft,
    arrowsRight,
    successPath,
    leadSource,
  } = data;

  const [registerInterestText, setRegisterInterestText] = useState(
    postcodeNotSearchedText,
  );

  useEffect(() => {
    setRegisterInterestText(
      !currentAddress?.uprn
        ? postcodeNotSearchedText
        : currentAddress?.orderable
          ? orderableText
          : !currentAddress?.orderable
            ? unorderableText
            : postcodeNotSearchedText,
    );
  }, [currentAddress]);

  return (
    <div
      className={`${backgroundColor} modular-register-interest-form-container`}
    >
      <div
        className={`modular-global-width modular-heading-secondary modular-text-center modular-p ${
          noBottomPadding && 'modular-padding-large-no-bottom'
        } ${noTopPadding && 'modular-padding-large-no-top'} ${
          !noBottomPadding && !noBottomPadding && 'modular-padding-large'
        }`}
      >
        <div className="text">
          {' '}
          <LitStructuredText data={registerInterestText} />
        </div>
        <PostcodeRegisterInterestSwitch
          successPath={successPath}
          leadSource={leadSource}
          arrowsLeft={arrowsLeft}
          arrowsRight={arrowsRight}
          isModularBlock={true}
        />
        {smallText && (
          <div className="text">
            {' '}
            <LitStructuredText data={smallText} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ModularRegisterInterestForm;

export const query = () =>
  useStaticQuery(graphql`
    {
      allDatoCmsNetworkCoverageModel {
        nodes {
          inBuild
          areaName
          available
          region
        }
      }
    }
  `);

export const fragment = graphql`
  fragment ModularRegisterInterestForm on DatoCmsRegisterInterestForm {
    internal {
      type
    }
    id
    successPath
    leadSource
    backgroundColor
    noBottomPadding
    noTopPadding
    orderableText {
      value
    }
    unorderableText {
      value
    }
    postcodeNotSearchedText {
      value
    }
    smallText {
      value
    }
    arrowsLeft {
      gatsbyImageData
    }
    arrowsRight {
      gatsbyImageData
    }
  }
`;
